<!-- 企业文化页面 -->
<template>
  <div class="culture-container">
    <!-- Top Banner -->
    <img class="img-top" src="../../assets/img/企业文化-顶图.webp" @load="imageLoaded = true" @error="imageLoaded = true" alt="" />

    <!-- Vision & Philosophy Section -->
    <div class="values-section" v-if="imageLoaded">
      <div class="values-grid">
        <!-- Vision Card -->
        <div class="value-card vision-card">
          <div class="card-icon">
            <span>🎯</span>
          </div>
          <h2 class="card-heading">{{ $t('culture.sloganTitle') }}</h2>
          <div class="quote-list">
            <p class="quote-item">{{ $t('culture.slogan1') }}</p>
            <p class="quote-item">{{ $t('culture.slogan2') }}</p>
          </div>
        </div>
        <!-- Philosophy Card -->
        <div class="value-card philosophy-card">
          <div class="card-icon">
            <span>💡</span>
          </div>
          <h2 class="card-heading">{{ $t('culture.philosophyTitle') }}</h2>
          <p class="philosophy-text">{{ $t('culture.philosophy') }}</p>
        </div>
      </div>
    </div>

    <!-- Photo Gallery Section -->
    <div class="gallery-section" v-if="imageLoaded">
      <div class="gallery-header">
        <h2>{{ $i18n.locale === 'zh' ? '企业风采' : 'Company Gallery' }}</h2>
        <p>{{ $i18n.locale === 'zh' ? '记录每一个精彩瞬间' : 'Capturing every wonderful moment' }}</p>
      </div>
      <div class="gallery-grid">
        <div
          class="gallery-item"
          v-for="(item, i) in img_datas"
          :key="i"
          @click="openGallery(i)"
        >
          <img :src="item.min" alt="" class="gallery-thumb" />
        </div>
      </div>

      <!-- Gallery Lightbox -->
      <div class="gallery-lightbox" v-if="lightboxVisible" @click="lightboxVisible = false"
        @touchmove.prevent @mousewheel.prevent>
        <div class="gallery-lightbox-mask"></div>
        <div class="gallery-lightbox-body" @click.stop>
          <button class="gallery-lightbox-close" @click="lightboxVisible = false">✕</button>
          <button class="gallery-lightbox-arrow gallery-lightbox-prev"
            @click.stop="prevImage" v-if="currentIndex > 0">
            <span>‹</span>
          </button>
          <img :src="img_datas[currentIndex].max" alt="" class="gallery-lightbox-img" />
          <button class="gallery-lightbox-arrow gallery-lightbox-next"
            @click.stop="nextImage" v-if="currentIndex < img_datas.length - 1">
            <span>›</span>
          </button>
          <span class="gallery-lightbox-counter">{{ currentIndex + 1 }} / {{ img_datas.length }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t('culture.seoTitle'),
      meta: [
        {
          name: "description",
          content: this.$t('culture.seoDescription'),
        },
        {
          name: "keywords",
          content: this.$t('culture.seoKeywords'),
        },
      ],
    }
  },
  data() {
    return {
      imageLoaded: false,
      lightboxVisible: false,
      currentIndex: 0,
      img_datas: [
        { min: require('@/assets/img/照片/1-1.webp'), max: require('@/assets/img/照片/1.webp') },
        { min: require('@/assets/img/照片/2-1.webp'), max: require('@/assets/img/照片/2.webp') },
        { min: require('@/assets/img/照片/3-1.webp'), max: require('@/assets/img/照片/3.webp') },
        { min: require('@/assets/img/照片/4-1.webp'), max: require('@/assets/img/照片/4.webp') },
        { min: require('@/assets/img/照片/5-1.webp'), max: require('@/assets/img/照片/5.webp') },
        { min: require('@/assets/img/照片/6-1.webp'), max: require('@/assets/img/照片/6.webp') },
        { min: require('@/assets/img/照片/7-1.webp'), max: require('@/assets/img/照片/7.webp') },
        { min: require('@/assets/img/照片/8-1.webp'), max: require('@/assets/img/照片/8.webp') },
      ],
    };
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
    setTimeout(() => {
      this.imageLoaded = true;
    }, 50);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    openGallery(index) {
      this.currentIndex = index;
      this.lightboxVisible = true;
    },
    prevImage() {
      if (this.currentIndex > 0) this.currentIndex--;
    },
    nextImage() {
      if (this.currentIndex < this.img_datas.length - 1) this.currentIndex++;
    },
    handleKeydown(e) {
      if (!this.lightboxVisible) return;
      if (e.key === 'Escape') this.lightboxVisible = false;
      if (e.key === 'ArrowLeft') this.prevImage();
      if (e.key === 'ArrowRight') this.nextImage();
    },
  },
};
</script>
<style lang="scss" scoped>
.culture-container {
  width: 100%;
  height: auto;

  .img-top {
    width: 100%;
    height: auto;
    display: block;

    @media (max-width: 768px) {
      margin-top: 30px;
    }
  }

  // ========== Values Section ==========
  .values-section {
    max-width: 1150px;
    width: 100%;
    padding: 80px 20px 60px;
    margin: 0 auto;

    @media (max-width: 768px) {
      padding: 40px 16px;
    }
  }

  .values-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  .value-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px 32px;
    position: relative;
    overflow: hidden;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
      padding: 28px 20px;
    }
  }

  .vision-card {
    border-top: 4px solid #d53434;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  }

  .philosophy-card {
    background: linear-gradient(135deg, #d53434 0%, #b71c1c 100%);
    box-shadow: 0 4px 24px rgba(213, 52, 52, 0.25);

    &:hover {
      box-shadow: 0 12px 40px rgba(213, 52, 52, 0.35);
    }

    .card-heading,
    .philosophy-text {
      color: #fff;
    }

    .card-icon span {
      filter: brightness(1.2);
    }
  }

  .card-icon {
    margin-bottom: 16px;

    span {
      font-size: 36px;
      @media (max-width: 768px) {
        font-size: 28px;
      }
    }
  }

  .card-heading {
    font-size: 26px;
    margin: 0 0 20px;
    color: #1a1a1a;

    .lang-en & {
      font-size: 22px;
    }

    @media (max-width: 768px) {
      font-size: 22px;
      .lang-en & {
        font-size: 18px;
      }
    }
  }

  .quote-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .quote-item {
    font-size: 17px;
    color: #555;
    line-height: 1.8;
    margin: 0;
    padding-left: 16px;
    border-left: 3px solid #f0d0d0;
    font-style: italic;

    .lang-en & {
      font-size: 14px;
      line-height: 1.6;
    }

    @media (max-width: 768px) {
      font-size: 15px;
      .lang-en & {
        font-size: 13px;
      }
    }
  }

  .philosophy-text {
    font-size: 20px;
    color: #fff;
    line-height: 1.8;
    margin: 0;
    font-weight: 500;

    .lang-en & {
      font-size: 17px;
      line-height: 1.6;
    }

    @media (max-width: 768px) {
      font-size: 17px;
      .lang-en & {
        font-size: 15px;
      }
    }
  }

  // ========== Gallery Section ==========
  .gallery-section {
    background: #f5f7fb;
    padding: 60px 20px 80px;

    @media (max-width: 768px) {
      padding: 40px 16px 60px;
    }
  }

  .gallery-header {
    text-align: center;
    margin-bottom: 40px;

    h2 {
      font-size: 32px;
      color: #1a1a1a;
      margin: 0 0 10px;

      @media (max-width: 768px) {
        font-size: 24px;
      }
    }

    p {
      font-size: 15px;
      color: #999;
      margin: 0;

      @media (max-width: 768px) {
        font-size: 13px;
      }
    }
  }

  .gallery-grid {
    max-width: 1150px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
  }

  .gallery-item {
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    aspect-ratio: 4 / 3;
    background: #e8e8e8;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
      transform: scale(1.03);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    }

    .gallery-thumb {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  // ========== Gallery Lightbox ==========
  .gallery-lightbox {
    position: fixed; inset: 0; z-index: 9999;
    display: flex; align-items: center; justify-content: center;
  }
  .gallery-lightbox-mask {
    position: absolute; inset: 0;
    background: rgba(0, 0, 0, 0.88);
  }
  .gallery-lightbox-body {
    position: relative; z-index: 1;
    max-width: 90vw; max-height: 90vh;
    display: flex; align-items: center; justify-content: center;
  }
  .gallery-lightbox-img {
    max-width: 90vw; max-height: 85vh;
    object-fit: contain; border-radius: 4px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  }
  .gallery-lightbox-close {
    position: fixed; top: 20px; right: 24px; z-index: 2;
    background: none; border: none; color: #fff; font-size: 32px;
    cursor: pointer; opacity: 0.7; transition: opacity 0.2s;
    &:hover { opacity: 1; }
  }
  .gallery-lightbox-arrow {
    position: fixed; top: 50%; transform: translateY(-50%); z-index: 2;
    background: rgba(0, 0, 0, 0.55); border: none; color: #fff;
    font-size: 48px; width: 56px; height: 80px; cursor: pointer;
    transition: background 0.2s;
    display: flex; align-items: center; justify-content: center;
    &:hover { background: rgba(0, 0, 0, 0.75); }
    span { text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5); }
    @media (max-width: 768px) { font-size: 32px; width: 40px; height: 56px; }
  }
  .gallery-lightbox-prev { left: 8px; border-radius: 0 8px 8px 0; }
  .gallery-lightbox-next { right: 8px; border-radius: 8px 0 0 8px; }
  .gallery-lightbox-counter {
    position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.6); font-size: 14px; z-index: 2;
  }
}
</style>
